import {
  Globe,
  HelpCircle,
  Mail,
  MessageCircle,
  Monitor,
  Phone,
  Wrench,
} from 'lucide-react';

const ICON_SIZE = 15;

export default function ChannelIcon({ code }: { code: string | undefined }) {
  const normalized = (code ?? '').toUpperCase();
  const props = { size: ICON_SIZE, strokeWidth: 2, 'aria-hidden': true as const };

  switch (normalized) {
    case 'EMAIL':
      return <Mail {...props} />;
    case 'WHATSAPP':
      return <Phone {...props} className="channel-icon-whatsapp" />;
    case 'WEBSITE':
      return <Globe {...props} />;
    case 'MANUAL':
      return <Wrench {...props} />;
    case 'PARENTHUB':
    case 'GARAGES':
    case 'FLOWWW':
    case 'LMS':
    case 'ERP':
      return <Monitor {...props} />;
    default:
      if (normalized.includes('CHAT') || normalized.includes('WIDGET')) {
        return <MessageCircle {...props} />;
      }
      return <HelpCircle {...props} />;
  }
}
